import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  saveAuthData,
  saveModule,
  saveStoreData,
  saveUserData,
} from "../../features/login/LoginSlice";

export const useAuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authToken = useSelector(
    (state) => state.loginSlice.authData?.accessToken
  );
  const { authData } = useSelector((state) => state.loginSlice);

  const handleAuthFlow = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth = JSON.parse(queryParams.get("auth"));
    const navbar = queryParams.get("navbar") ? queryParams.get("navbar") : [];
    const authorizations = JSON.parse(queryParams.get("authorization"));
    const isAdmin = JSON.parse(queryParams.get("isAdmin"));
    const storeId = queryParams.get("storeId");

    const secondAppUrl = `${process.env.REACT_APP_API_FRONTEND_URL_NODE}/login`;

    if (!authToken && !auth) {
      const redirectUrl = window.location.origin + window.location.pathname;
      const applicationName = "RSF";

      window.location.href = `${secondAppUrl}?redirectUrl=${encodeURIComponent(
        redirectUrl
      )}&appName=${encodeURIComponent(applicationName)}`;
      return;
    }
    let canRead = authorizations.includes("MULTI_STORES");

    dispatch(
      saveAuthData({
        accessToken: auth?.accessToken,
        refreshToken: auth?.refreshToken,
      })
    );

    const userDetails = {
      permissions: authorizations || [],
      isAdmin: isAdmin || false,
    };
    dispatch(saveModule(navbar));
    dispatch(saveUserData(userDetails));
    dispatch(saveStoreData({ storeId: storeId || null }));

    if (!canRead) {
      navigate("/orders");
    } else {
      navigate("/services");
    }
  };

  return {
    handleAuthFlow,
  };
};
